import { useMutation, useQuery } from '@apollo/client';
import { Button } from '@loomhq/lens';
import React from 'react';
import { useSelector } from 'react-redux';

import { PROFILE_FOLLOWED, PROFILE_UNFOLLOWED } from 'constants/events';
import { ROLLOUT_DESTINATION_FOLLOWS_BASIC } from 'constants/featureFlag';
import { selectCurrentUser } from 'selectors/user';
import { track } from 'utilities/analytics';

import { useGetSelectedWorkspace } from 'hooks/workspace';

import GetUserFollowsProfile from '../../creators/follows/GetUserFollowsProfile.graphql';
import ToggleFollowingProfile from '../../creators/follows/ToggleFollowingProfile.graphql';

import FeatureFlaggedComponent from 'components/feature-flag-wrapper';

const FollowButton = ({ profileId, hasFullWidth }) => {
  const selectedWorkspace = useGetSelectedWorkspace();
  const user = useSelector(selectCurrentUser);

  const { data: followData, loading } = useQuery(GetUserFollowsProfile, {
    variables: {
      profileId,
    },
  });
  const followsProfile = followData?.result?.follow;

  const [toggleFollow, { loading: toggleLoading }] = useMutation(
    ToggleFollowingProfile,
    {
      variables: {
        profileId,
        follow: !followsProfile,
      },
      refetchQueries: ['GetUserFollowsProfile', 'GetUserFollowedStreams'],
      awaitRefetchQueries: true,
    }
  );

  const onToggleFollow = () => {
    const event = !followsProfile ? PROFILE_FOLLOWED : PROFILE_UNFOLLOWED;

    track(event, {
      user_id: user.id,
      profile_id: profileId,
      organization_id: selectedWorkspace.id,
      context_page_path: window.location.pathname,
    });

    toggleFollow();
  };

  if (loading) {
    return null;
  }

  return (
    <FeatureFlaggedComponent
      flag={ROLLOUT_DESTINATION_FOLLOWS_BASIC}
      activationValues={[true]}
    >
      <Button
        hasFullWidth={hasFullWidth}
        variant={followsProfile ? 'neutral' : 'primary'}
        onClick={onToggleFollow}
        hasLoader={toggleLoading}
        isDisabled={toggleLoading}
      >
        {followsProfile ? 'Unfollow' : 'Follow'}
      </Button>
    </FeatureFlaggedComponent>
  );
};

export default FollowButton;
